"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasskeyAuthenticationChallengeAnswer = exports.VendorIntegrityChallengeAnswer = exports.InternalIdentityVerificationChallengeAnswer = exports.SelectCommunicationChannelAnswer = exports.TOTPChallengeAnswer = exports.TwoFAChallengeAnswer = exports.TIVChallengeAnswer = exports.SecurityQuestionChallengeAnswer = exports.PasswordChallengeAnswer = exports.OTPChallengeAnswer = exports.RequestResumeChallengeLoopAnswer = exports.WebViewChallengeAnswer = exports.CommunicationChannelVerificationAnswer_ResendRequest = exports.CommunicationChannelVerificationAnswer = exports.CommunicationChannelInputAnswer_PhoneInput = exports.CommunicationChannelInputAnswer = exports.CommunicationChannelChallengeAnswer = exports.ChallengeAnswer = exports.TransparentChallengeAnswer = exports.AppChallengeAnswer = exports.SelectCommunicationChannel = exports.InternalIdentityVerificationChallenge = exports.TOTPChallenge = exports.TwoFAChallenge = exports.TIVChallenge = exports.SecurityQuestionChallenge = exports.PasswordChallenge = exports.VendorIntegrityChallenge = exports.OTPChallenge = exports.PasskeyAuthenticationChallenge = exports.WebViewChallenge = exports.CommunicationChannelVerificationChallenge = exports.CommunicationChannelInputChallenge_PhoneVerifyOptionsMapEntry = exports.CommunicationChannelInputChallenge = exports.CommunicationChannelChallenge = exports.ChallengeData = exports.TransparentChallenge = exports.AppChallengeData = exports.RequestResumeChallengeLoopAnswer_Reason = exports.WebViewChallengeAnswer_WebViewChallengeError = exports.TOTPChallenge_Reason = exports.OTPChallenge_Reason = exports.CommunicationChannelInputChallenge_CommunicationChannelOptions = exports.SecurityQuestionType = void 0;
const login_bootstrap_1 = require("./login_bootstrap");
const passkey_authentication_options_1 = require("./passkey_authentication_options");
const passkey_authentication_payload_1 = require("./passkey_authentication_payload");
const date_1 = require("../../google/type/date");
const minimal_1 = __importDefault(require("protobufjs/minimal"));
/** Enum that describes the type of security question being posed. */
var SecurityQuestionType;
(function (SecurityQuestionType) {
    /** SECURITY_QUESTION_TYPE_UNSET - Default, unspecified value. */
    SecurityQuestionType[SecurityQuestionType["SECURITY_QUESTION_TYPE_UNSET"] = 0] = "SECURITY_QUESTION_TYPE_UNSET";
    /** PHONE_NUMBER - Security question prompting for the user's phone number. */
    SecurityQuestionType[SecurityQuestionType["PHONE_NUMBER"] = 1] = "PHONE_NUMBER";
    /** EMAIL_ADDRESS - Security question prompting for the user's email address. */
    SecurityQuestionType[SecurityQuestionType["EMAIL_ADDRESS"] = 2] = "EMAIL_ADDRESS";
    /** BIRTHDATE - Security question prompting for the user's birthdate. */
    SecurityQuestionType[SecurityQuestionType["BIRTHDATE"] = 3] = "BIRTHDATE";
    /** USERNAME - Security question prompting for the user's username. */
    SecurityQuestionType[SecurityQuestionType["USERNAME"] = 4] = "USERNAME";
    SecurityQuestionType[SecurityQuestionType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SecurityQuestionType = exports.SecurityQuestionType || (exports.SecurityQuestionType = {}));
/** CommunicationChannelOptions specifies which communication channels to present to the user */
var CommunicationChannelInputChallenge_CommunicationChannelOptions;
(function (CommunicationChannelInputChallenge_CommunicationChannelOptions) {
    /** UNSET - Default value, this should never happen */
    CommunicationChannelInputChallenge_CommunicationChannelOptions[CommunicationChannelInputChallenge_CommunicationChannelOptions["UNSET"] = 0] = "UNSET";
    /** EMAIL_ONLY - The email option is shown, with no option to switch to phone */
    CommunicationChannelInputChallenge_CommunicationChannelOptions[CommunicationChannelInputChallenge_CommunicationChannelOptions["EMAIL_ONLY"] = 1] = "EMAIL_ONLY";
    /** PHONE_ONLY - The phone option is shown, with no option to switch to email */
    CommunicationChannelInputChallenge_CommunicationChannelOptions[CommunicationChannelInputChallenge_CommunicationChannelOptions["PHONE_ONLY"] = 2] = "PHONE_ONLY";
    /** EMAIL_FIRST_PHONE_SWITCHABLE - The email option is shown, but the user has the option to switch to phone */
    CommunicationChannelInputChallenge_CommunicationChannelOptions[CommunicationChannelInputChallenge_CommunicationChannelOptions["EMAIL_FIRST_PHONE_SWITCHABLE"] = 3] = "EMAIL_FIRST_PHONE_SWITCHABLE";
    /** PHONE_FIRST_EMAIL_SWITCHABLE - The phone option is shown, but the user has the option to switch to email */
    CommunicationChannelInputChallenge_CommunicationChannelOptions[CommunicationChannelInputChallenge_CommunicationChannelOptions["PHONE_FIRST_EMAIL_SWITCHABLE"] = 4] = "PHONE_FIRST_EMAIL_SWITCHABLE";
    CommunicationChannelInputChallenge_CommunicationChannelOptions[CommunicationChannelInputChallenge_CommunicationChannelOptions["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CommunicationChannelInputChallenge_CommunicationChannelOptions = exports.CommunicationChannelInputChallenge_CommunicationChannelOptions || (exports.CommunicationChannelInputChallenge_CommunicationChannelOptions = {}));
/** The reason this challenge was issued. */
var OTPChallenge_Reason;
(function (OTPChallenge_Reason) {
    /** REASON_UNSET - Default, unspecified value. */
    OTPChallenge_Reason[OTPChallenge_Reason["REASON_UNSET"] = 0] = "REASON_UNSET";
    /** ATO_RISK - Issued due to Account Takeover risk. */
    OTPChallenge_Reason[OTPChallenge_Reason["ATO_RISK"] = 1] = "ATO_RISK";
    /** TWO_FA - Issued as part of Two-Factor Authentication. */
    OTPChallenge_Reason[OTPChallenge_Reason["TWO_FA"] = 2] = "TWO_FA";
    OTPChallenge_Reason[OTPChallenge_Reason["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(OTPChallenge_Reason = exports.OTPChallenge_Reason || (exports.OTPChallenge_Reason = {}));
/** The reason this challenge was issued. */
var TOTPChallenge_Reason;
(function (TOTPChallenge_Reason) {
    /** REASON_UNSET - Default, unspecified value. */
    TOTPChallenge_Reason[TOTPChallenge_Reason["REASON_UNSET"] = 0] = "REASON_UNSET";
    /** ATO_RISK - Issued due to Account Takeover risk. */
    TOTPChallenge_Reason[TOTPChallenge_Reason["ATO_RISK"] = 1] = "ATO_RISK";
    /** TWO_FA - Issued as part of Two-Factor Authentication. */
    TOTPChallenge_Reason[TOTPChallenge_Reason["TWO_FA"] = 2] = "TWO_FA";
    TOTPChallenge_Reason[TOTPChallenge_Reason["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(TOTPChallenge_Reason = exports.TOTPChallenge_Reason || (exports.TOTPChallenge_Reason = {}));
/** Types of error reported to the native client by the webview. */
var WebViewChallengeAnswer_WebViewChallengeError;
(function (WebViewChallengeAnswer_WebViewChallengeError) {
    /** WEBVIEW_CHALLENGE_ERROR_UNKNOWN_UNSET - Unknown. */
    WebViewChallengeAnswer_WebViewChallengeError[WebViewChallengeAnswer_WebViewChallengeError["WEBVIEW_CHALLENGE_ERROR_UNKNOWN_UNSET"] = 0] = "WEBVIEW_CHALLENGE_ERROR_UNKNOWN_UNSET";
    /**
     * WEBVIEW_CHALLENGE_ERROR_LOAD_TIMEOUT - The challenge failed to load in the allowed time.
     * This can be due to a server-side issue or a client-side issue or a network issue.
     * The client might be able to run the challenge after a retry.
     */
    WebViewChallengeAnswer_WebViewChallengeError[WebViewChallengeAnswer_WebViewChallengeError["WEBVIEW_CHALLENGE_ERROR_LOAD_TIMEOUT"] = 1] = "WEBVIEW_CHALLENGE_ERROR_LOAD_TIMEOUT";
    /**
     * WEBVIEW_CHALLENGE_ERROR_INTERNAL_ERROR - Error while executing the challenge. answer_payload may contains more useful information on the error
     * for the server to decide how to handle it (fail open/close or ask for a retry)
     */
    WebViewChallengeAnswer_WebViewChallengeError[WebViewChallengeAnswer_WebViewChallengeError["WEBVIEW_CHALLENGE_ERROR_INTERNAL_ERROR"] = 2] = "WEBVIEW_CHALLENGE_ERROR_INTERNAL_ERROR";
    WebViewChallengeAnswer_WebViewChallengeError[WebViewChallengeAnswer_WebViewChallengeError["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(WebViewChallengeAnswer_WebViewChallengeError = exports.WebViewChallengeAnswer_WebViewChallengeError || (exports.WebViewChallengeAnswer_WebViewChallengeError = {}));
/** Possible reasons for the client not to have any challenge */
var RequestResumeChallengeLoopAnswer_Reason;
(function (RequestResumeChallengeLoopAnswer_Reason) {
    /** UNSET - Unset */
    RequestResumeChallengeLoopAnswer_Reason[RequestResumeChallengeLoopAnswer_Reason["UNSET"] = 0] = "UNSET";
    /** RESUMING_REGISTRATION - Registration was resumed and the challenge context was lost */
    RequestResumeChallengeLoopAnswer_Reason[RequestResumeChallengeLoopAnswer_Reason["RESUMING_REGISTRATION"] = 1] = "RESUMING_REGISTRATION";
    RequestResumeChallengeLoopAnswer_Reason[RequestResumeChallengeLoopAnswer_Reason["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(RequestResumeChallengeLoopAnswer_Reason = exports.RequestResumeChallengeLoopAnswer_Reason || (exports.RequestResumeChallengeLoopAnswer_Reason = {}));
function createBaseAppChallengeData() {
    return { transparentChallenges: [], visibleChallenge: undefined };
}
exports.AppChallengeData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.transparentChallenges) {
            exports.TransparentChallenge.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.visibleChallenge?.$case === "communicationChannelInputChallenge") {
            exports.CommunicationChannelInputChallenge.encode(message.visibleChallenge.communicationChannelInputChallenge, writer.uint32(50).fork()).ldelim();
        }
        if (message.visibleChallenge?.$case ===
            "communicationChannelVerificationChallenge") {
            exports.CommunicationChannelVerificationChallenge.encode(message.visibleChallenge.communicationChannelVerificationChallenge, writer.uint32(58).fork()).ldelim();
        }
        if (message.visibleChallenge?.$case === "webViewChallenge") {
            exports.WebViewChallenge.encode(message.visibleChallenge.webViewChallenge, writer.uint32(66).fork()).ldelim();
        }
        if (message.visibleChallenge?.$case === "passkeyAuthenticationChallenge") {
            exports.PasskeyAuthenticationChallenge.encode(message.visibleChallenge.passkeyAuthenticationChallenge, writer.uint32(74).fork()).ldelim();
        }
        if (message.visibleChallenge?.$case === "otpChallenge") {
            exports.OTPChallenge.encode(message.visibleChallenge.otpChallenge, writer.uint32(82).fork()).ldelim();
        }
        if (message.visibleChallenge?.$case === "securityQuestionChallenge") {
            exports.SecurityQuestionChallenge.encode(message.visibleChallenge.securityQuestionChallenge, writer.uint32(90).fork()).ldelim();
        }
        if (message.visibleChallenge?.$case === "totpChallenge") {
            exports.TOTPChallenge.encode(message.visibleChallenge.totpChallenge, writer.uint32(98).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAppChallengeData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.transparentChallenges.push(exports.TransparentChallenge.decode(reader, reader.uint32()));
                    break;
                case 6:
                    message.visibleChallenge = {
                        $case: "communicationChannelInputChallenge",
                        communicationChannelInputChallenge: exports.CommunicationChannelInputChallenge.decode(reader, reader.uint32()),
                    };
                    break;
                case 7:
                    message.visibleChallenge = {
                        $case: "communicationChannelVerificationChallenge",
                        communicationChannelVerificationChallenge: exports.CommunicationChannelVerificationChallenge.decode(reader, reader.uint32()),
                    };
                    break;
                case 8:
                    message.visibleChallenge = {
                        $case: "webViewChallenge",
                        webViewChallenge: exports.WebViewChallenge.decode(reader, reader.uint32()),
                    };
                    break;
                case 9:
                    message.visibleChallenge = {
                        $case: "passkeyAuthenticationChallenge",
                        passkeyAuthenticationChallenge: exports.PasskeyAuthenticationChallenge.decode(reader, reader.uint32()),
                    };
                    break;
                case 10:
                    message.visibleChallenge = {
                        $case: "otpChallenge",
                        otpChallenge: exports.OTPChallenge.decode(reader, reader.uint32()),
                    };
                    break;
                case 11:
                    message.visibleChallenge = {
                        $case: "securityQuestionChallenge",
                        securityQuestionChallenge: exports.SecurityQuestionChallenge.decode(reader, reader.uint32()),
                    };
                    break;
                case 12:
                    message.visibleChallenge = {
                        $case: "totpChallenge",
                        totpChallenge: exports.TOTPChallenge.decode(reader, reader.uint32()),
                    };
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseAppChallengeData();
        message.transparentChallenges =
            object.transparentChallenges?.map((e) => exports.TransparentChallenge.fromPartial(e)) || [];
        if (object.visibleChallenge?.$case === "communicationChannelInputChallenge" &&
            object.visibleChallenge?.communicationChannelInputChallenge !==
                undefined &&
            object.visibleChallenge?.communicationChannelInputChallenge !== null) {
            message.visibleChallenge = {
                $case: "communicationChannelInputChallenge",
                communicationChannelInputChallenge: exports.CommunicationChannelInputChallenge.fromPartial(object.visibleChallenge.communicationChannelInputChallenge),
            };
        }
        if (object.visibleChallenge?.$case ===
            "communicationChannelVerificationChallenge" &&
            object.visibleChallenge?.communicationChannelVerificationChallenge !==
                undefined &&
            object.visibleChallenge?.communicationChannelVerificationChallenge !==
                null) {
            message.visibleChallenge = {
                $case: "communicationChannelVerificationChallenge",
                communicationChannelVerificationChallenge: exports.CommunicationChannelVerificationChallenge.fromPartial(object.visibleChallenge.communicationChannelVerificationChallenge),
            };
        }
        if (object.visibleChallenge?.$case === "webViewChallenge" &&
            object.visibleChallenge?.webViewChallenge !== undefined &&
            object.visibleChallenge?.webViewChallenge !== null) {
            message.visibleChallenge = {
                $case: "webViewChallenge",
                webViewChallenge: exports.WebViewChallenge.fromPartial(object.visibleChallenge.webViewChallenge),
            };
        }
        if (object.visibleChallenge?.$case === "passkeyAuthenticationChallenge" &&
            object.visibleChallenge?.passkeyAuthenticationChallenge !== undefined &&
            object.visibleChallenge?.passkeyAuthenticationChallenge !== null) {
            message.visibleChallenge = {
                $case: "passkeyAuthenticationChallenge",
                passkeyAuthenticationChallenge: exports.PasskeyAuthenticationChallenge.fromPartial(object.visibleChallenge.passkeyAuthenticationChallenge),
            };
        }
        if (object.visibleChallenge?.$case === "otpChallenge" &&
            object.visibleChallenge?.otpChallenge !== undefined &&
            object.visibleChallenge?.otpChallenge !== null) {
            message.visibleChallenge = {
                $case: "otpChallenge",
                otpChallenge: exports.OTPChallenge.fromPartial(object.visibleChallenge.otpChallenge),
            };
        }
        if (object.visibleChallenge?.$case === "securityQuestionChallenge" &&
            object.visibleChallenge?.securityQuestionChallenge !== undefined &&
            object.visibleChallenge?.securityQuestionChallenge !== null) {
            message.visibleChallenge = {
                $case: "securityQuestionChallenge",
                securityQuestionChallenge: exports.SecurityQuestionChallenge.fromPartial(object.visibleChallenge.securityQuestionChallenge),
            };
        }
        if (object.visibleChallenge?.$case === "totpChallenge" &&
            object.visibleChallenge?.totpChallenge !== undefined &&
            object.visibleChallenge?.totpChallenge !== null) {
            message.visibleChallenge = {
                $case: "totpChallenge",
                totpChallenge: exports.TOTPChallenge.fromPartial(object.visibleChallenge.totpChallenge),
            };
        }
        return message;
    },
};
function createBaseTransparentChallenge() {
    return { payload: undefined };
}
exports.TransparentChallenge = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.payload?.$case === "vendorIntegrityChallenge") {
            exports.VendorIntegrityChallenge.encode(message.payload.vendorIntegrityChallenge, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTransparentChallenge();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.payload = {
                        $case: "vendorIntegrityChallenge",
                        vendorIntegrityChallenge: exports.VendorIntegrityChallenge.decode(reader, reader.uint32()),
                    };
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseTransparentChallenge();
        if (object.payload?.$case === "vendorIntegrityChallenge" &&
            object.payload?.vendorIntegrityChallenge !== undefined &&
            object.payload?.vendorIntegrityChallenge !== null) {
            message.payload = {
                $case: "vendorIntegrityChallenge",
                vendorIntegrityChallenge: exports.VendorIntegrityChallenge.fromPartial(object.payload.vendorIntegrityChallenge),
            };
        }
        return message;
    },
};
function createBaseChallengeData() {
    return { challenge: undefined };
}
exports.ChallengeData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.challenge?.$case === "otpChallenge") {
            exports.OTPChallenge.encode(message.challenge.otpChallenge, writer.uint32(10).fork()).ldelim();
        }
        if (message.challenge?.$case === "passwordChallenge") {
            exports.PasswordChallenge.encode(message.challenge.passwordChallenge, writer.uint32(18).fork()).ldelim();
        }
        if (message.challenge?.$case === "securityQuestionChallenge") {
            exports.SecurityQuestionChallenge.encode(message.challenge.securityQuestionChallenge, writer.uint32(26).fork()).ldelim();
        }
        if (message.challenge?.$case === "tivChallenge") {
            exports.TIVChallenge.encode(message.challenge.tivChallenge, writer.uint32(34).fork()).ldelim();
        }
        if (message.challenge?.$case === "twoFaChallenge") {
            exports.TwoFAChallenge.encode(message.challenge.twoFaChallenge, writer.uint32(42).fork()).ldelim();
        }
        if (message.challenge?.$case === "selectCommunicationChannel") {
            exports.SelectCommunicationChannel.encode(message.challenge.selectCommunicationChannel, writer.uint32(50).fork()).ldelim();
        }
        if (message.challenge?.$case === "communicationChannelChallenge") {
            exports.CommunicationChannelChallenge.encode(message.challenge.communicationChannelChallenge, writer.uint32(58).fork()).ldelim();
        }
        if (message.challenge?.$case === "internalIdentityVerificationChallenge") {
            exports.InternalIdentityVerificationChallenge.encode(message.challenge.internalIdentityVerificationChallenge, writer.uint32(66).fork()).ldelim();
        }
        if (message.challenge?.$case === "vendorIntegrityChallenge") {
            exports.VendorIntegrityChallenge.encode(message.challenge.vendorIntegrityChallenge, writer.uint32(74).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChallengeData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.challenge = {
                        $case: "otpChallenge",
                        otpChallenge: exports.OTPChallenge.decode(reader, reader.uint32()),
                    };
                    break;
                case 2:
                    message.challenge = {
                        $case: "passwordChallenge",
                        passwordChallenge: exports.PasswordChallenge.decode(reader, reader.uint32()),
                    };
                    break;
                case 3:
                    message.challenge = {
                        $case: "securityQuestionChallenge",
                        securityQuestionChallenge: exports.SecurityQuestionChallenge.decode(reader, reader.uint32()),
                    };
                    break;
                case 4:
                    message.challenge = {
                        $case: "tivChallenge",
                        tivChallenge: exports.TIVChallenge.decode(reader, reader.uint32()),
                    };
                    break;
                case 5:
                    message.challenge = {
                        $case: "twoFaChallenge",
                        twoFaChallenge: exports.TwoFAChallenge.decode(reader, reader.uint32()),
                    };
                    break;
                case 6:
                    message.challenge = {
                        $case: "selectCommunicationChannel",
                        selectCommunicationChannel: exports.SelectCommunicationChannel.decode(reader, reader.uint32()),
                    };
                    break;
                case 7:
                    message.challenge = {
                        $case: "communicationChannelChallenge",
                        communicationChannelChallenge: exports.CommunicationChannelChallenge.decode(reader, reader.uint32()),
                    };
                    break;
                case 8:
                    message.challenge = {
                        $case: "internalIdentityVerificationChallenge",
                        internalIdentityVerificationChallenge: exports.InternalIdentityVerificationChallenge.decode(reader, reader.uint32()),
                    };
                    break;
                case 9:
                    message.challenge = {
                        $case: "vendorIntegrityChallenge",
                        vendorIntegrityChallenge: exports.VendorIntegrityChallenge.decode(reader, reader.uint32()),
                    };
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseChallengeData();
        if (object.challenge?.$case === "otpChallenge" &&
            object.challenge?.otpChallenge !== undefined &&
            object.challenge?.otpChallenge !== null) {
            message.challenge = {
                $case: "otpChallenge",
                otpChallenge: exports.OTPChallenge.fromPartial(object.challenge.otpChallenge),
            };
        }
        if (object.challenge?.$case === "passwordChallenge" &&
            object.challenge?.passwordChallenge !== undefined &&
            object.challenge?.passwordChallenge !== null) {
            message.challenge = {
                $case: "passwordChallenge",
                passwordChallenge: exports.PasswordChallenge.fromPartial(object.challenge.passwordChallenge),
            };
        }
        if (object.challenge?.$case === "securityQuestionChallenge" &&
            object.challenge?.securityQuestionChallenge !== undefined &&
            object.challenge?.securityQuestionChallenge !== null) {
            message.challenge = {
                $case: "securityQuestionChallenge",
                securityQuestionChallenge: exports.SecurityQuestionChallenge.fromPartial(object.challenge.securityQuestionChallenge),
            };
        }
        if (object.challenge?.$case === "tivChallenge" &&
            object.challenge?.tivChallenge !== undefined &&
            object.challenge?.tivChallenge !== null) {
            message.challenge = {
                $case: "tivChallenge",
                tivChallenge: exports.TIVChallenge.fromPartial(object.challenge.tivChallenge),
            };
        }
        if (object.challenge?.$case === "twoFaChallenge" &&
            object.challenge?.twoFaChallenge !== undefined &&
            object.challenge?.twoFaChallenge !== null) {
            message.challenge = {
                $case: "twoFaChallenge",
                twoFaChallenge: exports.TwoFAChallenge.fromPartial(object.challenge.twoFaChallenge),
            };
        }
        if (object.challenge?.$case === "selectCommunicationChannel" &&
            object.challenge?.selectCommunicationChannel !== undefined &&
            object.challenge?.selectCommunicationChannel !== null) {
            message.challenge = {
                $case: "selectCommunicationChannel",
                selectCommunicationChannel: exports.SelectCommunicationChannel.fromPartial(object.challenge.selectCommunicationChannel),
            };
        }
        if (object.challenge?.$case === "communicationChannelChallenge" &&
            object.challenge?.communicationChannelChallenge !== undefined &&
            object.challenge?.communicationChannelChallenge !== null) {
            message.challenge = {
                $case: "communicationChannelChallenge",
                communicationChannelChallenge: exports.CommunicationChannelChallenge.fromPartial(object.challenge.communicationChannelChallenge),
            };
        }
        if (object.challenge?.$case === "internalIdentityVerificationChallenge" &&
            object.challenge?.internalIdentityVerificationChallenge !== undefined &&
            object.challenge?.internalIdentityVerificationChallenge !== null) {
            message.challenge = {
                $case: "internalIdentityVerificationChallenge",
                internalIdentityVerificationChallenge: exports.InternalIdentityVerificationChallenge.fromPartial(object.challenge.internalIdentityVerificationChallenge),
            };
        }
        if (object.challenge?.$case === "vendorIntegrityChallenge" &&
            object.challenge?.vendorIntegrityChallenge !== undefined &&
            object.challenge?.vendorIntegrityChallenge !== null) {
            message.challenge = {
                $case: "vendorIntegrityChallenge",
                vendorIntegrityChallenge: exports.VendorIntegrityChallenge.fromPartial(object.challenge.vendorIntegrityChallenge),
            };
        }
        return message;
    },
};
function createBaseCommunicationChannelChallenge() {
    return {
        promptTitleText: "",
        promptSubtitleText: "",
        communicationChannel: 0,
        inputPrefill: undefined,
    };
}
exports.CommunicationChannelChallenge = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.promptTitleText !== "") {
            writer.uint32(10).string(message.promptTitleText);
        }
        if (message.promptSubtitleText !== "") {
            writer.uint32(18).string(message.promptSubtitleText);
        }
        if (message.communicationChannel !== 0) {
            writer.uint32(24).int32(message.communicationChannel);
        }
        if (message.inputPrefill?.$case === "email") {
            writer.uint32(34).string(message.inputPrefill.email);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommunicationChannelChallenge();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.promptTitleText = reader.string();
                    break;
                case 2:
                    message.promptSubtitleText = reader.string();
                    break;
                case 3:
                    message.communicationChannel = reader.int32();
                    break;
                case 4:
                    message.inputPrefill = { $case: "email", email: reader.string() };
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseCommunicationChannelChallenge();
        message.promptTitleText = object.promptTitleText ?? "";
        message.promptSubtitleText = object.promptSubtitleText ?? "";
        message.communicationChannel = object.communicationChannel ?? 0;
        if (object.inputPrefill?.$case === "email" &&
            object.inputPrefill?.email !== undefined &&
            object.inputPrefill?.email !== null) {
            message.inputPrefill = {
                $case: "email",
                email: object.inputPrefill.email,
            };
        }
        return message;
    },
};
function createBaseCommunicationChannelInputChallenge() {
    return {
        inputPrefill: undefined,
        communicationChannelOptions: 0,
        phoneVerifyOptionsMap: {},
    };
}
exports.CommunicationChannelInputChallenge = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.inputPrefill?.$case === "email") {
            writer.uint32(10).string(message.inputPrefill.email);
        }
        if (message.communicationChannelOptions !== 0) {
            writer.uint32(48).int32(message.communicationChannelOptions);
        }
        Object.entries(message.phoneVerifyOptionsMap).forEach(([key, value]) => {
            exports.CommunicationChannelInputChallenge_PhoneVerifyOptionsMapEntry.encode({ key: key, value }, writer.uint32(58).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommunicationChannelInputChallenge();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.inputPrefill = { $case: "email", email: reader.string() };
                    break;
                case 6:
                    message.communicationChannelOptions = reader.int32();
                    break;
                case 7:
                    const entry7 = exports.CommunicationChannelInputChallenge_PhoneVerifyOptionsMapEntry.decode(reader, reader.uint32());
                    if (entry7.value !== undefined) {
                        message.phoneVerifyOptionsMap[entry7.key] = entry7.value;
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseCommunicationChannelInputChallenge();
        if (object.inputPrefill?.$case === "email" &&
            object.inputPrefill?.email !== undefined &&
            object.inputPrefill?.email !== null) {
            message.inputPrefill = {
                $case: "email",
                email: object.inputPrefill.email,
            };
        }
        message.communicationChannelOptions =
            object.communicationChannelOptions ?? 0;
        message.phoneVerifyOptionsMap = Object.entries(object.phoneVerifyOptionsMap ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = login_bootstrap_1.VerificationStatus_PhoneVerifyOptions.fromPartial(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseCommunicationChannelInputChallenge_PhoneVerifyOptionsMapEntry() {
    return { key: "", value: undefined };
}
exports.CommunicationChannelInputChallenge_PhoneVerifyOptionsMapEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            login_bootstrap_1.VerificationStatus_PhoneVerifyOptions.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommunicationChannelInputChallenge_PhoneVerifyOptionsMapEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = login_bootstrap_1.VerificationStatus_PhoneVerifyOptions.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseCommunicationChannelInputChallenge_PhoneVerifyOptionsMapEntry();
        message.key = object.key ?? "";
        message.value =
            object.value !== undefined && object.value !== null
                ? login_bootstrap_1.VerificationStatus_PhoneVerifyOptions.fromPartial(object.value)
                : undefined;
        return message;
    },
};
function createBaseCommunicationChannelVerificationChallenge() {
    return { numDigits: 0, deliveryChannel: undefined };
}
exports.CommunicationChannelVerificationChallenge = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.numDigits !== 0) {
            writer.uint32(8).uint32(message.numDigits);
        }
        if (message.deliveryChannel?.$case === "email") {
            writer.uint32(18).string(message.deliveryChannel.email);
        }
        if (message.deliveryChannel?.$case === "phone") {
            writer.uint32(26).string(message.deliveryChannel.phone);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommunicationChannelVerificationChallenge();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.numDigits = reader.uint32();
                    break;
                case 2:
                    message.deliveryChannel = { $case: "email", email: reader.string() };
                    break;
                case 3:
                    message.deliveryChannel = { $case: "phone", phone: reader.string() };
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseCommunicationChannelVerificationChallenge();
        message.numDigits = object.numDigits ?? 0;
        if (object.deliveryChannel?.$case === "email" &&
            object.deliveryChannel?.email !== undefined &&
            object.deliveryChannel?.email !== null) {
            message.deliveryChannel = {
                $case: "email",
                email: object.deliveryChannel.email,
            };
        }
        if (object.deliveryChannel?.$case === "phone" &&
            object.deliveryChannel?.phone !== undefined &&
            object.deliveryChannel?.phone !== null) {
            message.deliveryChannel = {
                $case: "phone",
                phone: object.deliveryChannel.phone,
            };
        }
        return message;
    },
};
function createBaseWebViewChallenge() {
    return { content: undefined, timeoutSeconds: 0, pageTitle: "", provider: "" };
}
exports.WebViewChallenge = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.content?.$case === "url") {
            writer.uint32(10).string(message.content.url);
        }
        if (message.content?.$case === "html") {
            writer.uint32(18).string(message.content.html);
        }
        if (message.timeoutSeconds !== 0) {
            writer.uint32(24).uint32(message.timeoutSeconds);
        }
        if (message.pageTitle !== "") {
            writer.uint32(34).string(message.pageTitle);
        }
        if (message.provider !== "") {
            writer.uint32(42).string(message.provider);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebViewChallenge();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.content = { $case: "url", url: reader.string() };
                    break;
                case 2:
                    message.content = { $case: "html", html: reader.string() };
                    break;
                case 3:
                    message.timeoutSeconds = reader.uint32();
                    break;
                case 4:
                    message.pageTitle = reader.string();
                    break;
                case 5:
                    message.provider = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseWebViewChallenge();
        if (object.content?.$case === "url" &&
            object.content?.url !== undefined &&
            object.content?.url !== null) {
            message.content = { $case: "url", url: object.content.url };
        }
        if (object.content?.$case === "html" &&
            object.content?.html !== undefined &&
            object.content?.html !== null) {
            message.content = { $case: "html", html: object.content.html };
        }
        message.timeoutSeconds = object.timeoutSeconds ?? 0;
        message.pageTitle = object.pageTitle ?? "";
        message.provider = object.provider ?? "";
        return message;
    },
};
function createBasePasskeyAuthenticationChallenge() {
    return { passkeyAuthenticationOptions: undefined };
}
exports.PasskeyAuthenticationChallenge = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.passkeyAuthenticationOptions !== undefined) {
            passkey_authentication_options_1.PasskeyAuthenticationOptions.encode(message.passkeyAuthenticationOptions, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePasskeyAuthenticationChallenge();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.passkeyAuthenticationOptions =
                        passkey_authentication_options_1.PasskeyAuthenticationOptions.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBasePasskeyAuthenticationChallenge();
        message.passkeyAuthenticationOptions =
            object.passkeyAuthenticationOptions !== undefined &&
                object.passkeyAuthenticationOptions !== null
                ? passkey_authentication_options_1.PasskeyAuthenticationOptions.fromPartial(object.passkeyAuthenticationOptions)
                : undefined;
        return message;
    },
};
function createBaseOTPChallenge() {
    return {
        promptTitleText: "",
        promptSubtitleText: "",
        numDigits: 0,
        sentCommunicationChannels: [],
        reason: 0,
    };
}
exports.OTPChallenge = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.promptTitleText !== "") {
            writer.uint32(10).string(message.promptTitleText);
        }
        if (message.promptSubtitleText !== "") {
            writer.uint32(18).string(message.promptSubtitleText);
        }
        if (message.numDigits !== 0) {
            writer.uint32(24).uint32(message.numDigits);
        }
        writer.uint32(34).fork();
        for (const v of message.sentCommunicationChannels) {
            writer.int32(v);
        }
        writer.ldelim();
        if (message.reason !== 0) {
            writer.uint32(40).int32(message.reason);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOTPChallenge();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.promptTitleText = reader.string();
                    break;
                case 2:
                    message.promptSubtitleText = reader.string();
                    break;
                case 3:
                    message.numDigits = reader.uint32();
                    break;
                case 4:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.sentCommunicationChannels.push(reader.int32());
                        }
                    }
                    else {
                        message.sentCommunicationChannels.push(reader.int32());
                    }
                    break;
                case 5:
                    message.reason = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseOTPChallenge();
        message.promptTitleText = object.promptTitleText ?? "";
        message.promptSubtitleText = object.promptSubtitleText ?? "";
        message.numDigits = object.numDigits ?? 0;
        message.sentCommunicationChannels =
            object.sentCommunicationChannels?.map((e) => e) || [];
        message.reason = object.reason ?? 0;
        return message;
    },
};
function createBaseVendorIntegrityChallenge() {
    return { type: 0, nonce: new Uint8Array() };
}
exports.VendorIntegrityChallenge = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.type !== 0) {
            writer.uint32(8).int32(message.type);
        }
        if (message.nonce.length !== 0) {
            writer.uint32(18).bytes(message.nonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVendorIntegrityChallenge();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.nonce = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseVendorIntegrityChallenge();
        message.type = object.type ?? 0;
        message.nonce = object.nonce ?? new Uint8Array();
        return message;
    },
};
function createBasePasswordChallenge() {
    return { promptTitleText: "", promptSubtitleText: "" };
}
exports.PasswordChallenge = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.promptTitleText !== "") {
            writer.uint32(10).string(message.promptTitleText);
        }
        if (message.promptSubtitleText !== "") {
            writer.uint32(18).string(message.promptSubtitleText);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePasswordChallenge();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.promptTitleText = reader.string();
                    break;
                case 2:
                    message.promptSubtitleText = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBasePasswordChallenge();
        message.promptTitleText = object.promptTitleText ?? "";
        message.promptSubtitleText = object.promptSubtitleText ?? "";
        return message;
    },
};
function createBaseSecurityQuestionChallenge() {
    return { securityQuestionType: 0 };
}
exports.SecurityQuestionChallenge = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.securityQuestionType !== 0) {
            writer.uint32(8).int32(message.securityQuestionType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSecurityQuestionChallenge();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.securityQuestionType = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseSecurityQuestionChallenge();
        message.securityQuestionType = object.securityQuestionType ?? 0;
        return message;
    },
};
function createBaseTIVChallenge() {
    return {
        promptTitleText: "",
        promptSubtitleText: "",
        sentCommunicationChannels: [],
        transactionId: "",
        invalidAppVersion: false,
        authenticationSessionId: "",
        broadcastId: "",
        pushDevice: "",
        obfuscatedEmail: "",
        obfuscatedPhone: "",
    };
}
exports.TIVChallenge = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.promptTitleText !== "") {
            writer.uint32(10).string(message.promptTitleText);
        }
        if (message.promptSubtitleText !== "") {
            writer.uint32(18).string(message.promptSubtitleText);
        }
        writer.uint32(26).fork();
        for (const v of message.sentCommunicationChannels) {
            writer.int32(v);
        }
        writer.ldelim();
        if (message.transactionId !== "") {
            writer.uint32(34).string(message.transactionId);
        }
        if (message.invalidAppVersion === true) {
            writer.uint32(40).bool(message.invalidAppVersion);
        }
        if (message.authenticationSessionId !== "") {
            writer.uint32(50).string(message.authenticationSessionId);
        }
        if (message.broadcastId !== "") {
            writer.uint32(58).string(message.broadcastId);
        }
        if (message.pushDevice !== "") {
            writer.uint32(66).string(message.pushDevice);
        }
        if (message.obfuscatedEmail !== "") {
            writer.uint32(74).string(message.obfuscatedEmail);
        }
        if (message.obfuscatedPhone !== "") {
            writer.uint32(82).string(message.obfuscatedPhone);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTIVChallenge();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.promptTitleText = reader.string();
                    break;
                case 2:
                    message.promptSubtitleText = reader.string();
                    break;
                case 3:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.sentCommunicationChannels.push(reader.int32());
                        }
                    }
                    else {
                        message.sentCommunicationChannels.push(reader.int32());
                    }
                    break;
                case 4:
                    message.transactionId = reader.string();
                    break;
                case 5:
                    message.invalidAppVersion = reader.bool();
                    break;
                case 6:
                    message.authenticationSessionId = reader.string();
                    break;
                case 7:
                    message.broadcastId = reader.string();
                    break;
                case 8:
                    message.pushDevice = reader.string();
                    break;
                case 9:
                    message.obfuscatedEmail = reader.string();
                    break;
                case 10:
                    message.obfuscatedPhone = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseTIVChallenge();
        message.promptTitleText = object.promptTitleText ?? "";
        message.promptSubtitleText = object.promptSubtitleText ?? "";
        message.sentCommunicationChannels =
            object.sentCommunicationChannels?.map((e) => e) || [];
        message.transactionId = object.transactionId ?? "";
        message.invalidAppVersion = object.invalidAppVersion ?? false;
        message.authenticationSessionId = object.authenticationSessionId ?? "";
        message.broadcastId = object.broadcastId ?? "";
        message.pushDevice = object.pushDevice ?? "";
        message.obfuscatedEmail = object.obfuscatedEmail ?? "";
        message.obfuscatedPhone = object.obfuscatedPhone ?? "";
        return message;
    },
};
function createBaseTwoFAChallenge() {
    return {
        promptTitleText: "",
        promptSubtitleText: "",
        sentCommunicationChannels: [],
        enabledCommunicationChannels: [],
    };
}
exports.TwoFAChallenge = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.promptTitleText !== "") {
            writer.uint32(10).string(message.promptTitleText);
        }
        if (message.promptSubtitleText !== "") {
            writer.uint32(18).string(message.promptSubtitleText);
        }
        writer.uint32(26).fork();
        for (const v of message.sentCommunicationChannels) {
            writer.int32(v);
        }
        writer.ldelim();
        writer.uint32(34).fork();
        for (const v of message.enabledCommunicationChannels) {
            writer.int32(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTwoFAChallenge();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.promptTitleText = reader.string();
                    break;
                case 2:
                    message.promptSubtitleText = reader.string();
                    break;
                case 3:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.sentCommunicationChannels.push(reader.int32());
                        }
                    }
                    else {
                        message.sentCommunicationChannels.push(reader.int32());
                    }
                    break;
                case 4:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.enabledCommunicationChannels.push(reader.int32());
                        }
                    }
                    else {
                        message.enabledCommunicationChannels.push(reader.int32());
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseTwoFAChallenge();
        message.promptTitleText = object.promptTitleText ?? "";
        message.promptSubtitleText = object.promptSubtitleText ?? "";
        message.sentCommunicationChannels =
            object.sentCommunicationChannels?.map((e) => e) || [];
        message.enabledCommunicationChannels =
            object.enabledCommunicationChannels?.map((e) => e) || [];
        return message;
    },
};
function createBaseTOTPChallenge() {
    return { reason: 0 };
}
exports.TOTPChallenge = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.reason !== 0) {
            writer.uint32(8).int32(message.reason);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTOTPChallenge();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.reason = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseTOTPChallenge();
        message.reason = object.reason ?? 0;
        return message;
    },
};
function createBaseInternalIdentityVerificationChallenge() {
    return { authenticationSessionId: "" };
}
exports.InternalIdentityVerificationChallenge = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.authenticationSessionId !== "") {
            writer.uint32(10).string(message.authenticationSessionId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInternalIdentityVerificationChallenge();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.authenticationSessionId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseInternalIdentityVerificationChallenge();
        message.authenticationSessionId = object.authenticationSessionId ?? "";
        return message;
    },
};
function createBaseSelectCommunicationChannel() {
    return {
        promptTitleText: "",
        promptSubtitleText: "",
        obfuscatedPhone: "",
        obfuscatedEmail: "",
    };
}
exports.SelectCommunicationChannel = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.promptTitleText !== "") {
            writer.uint32(10).string(message.promptTitleText);
        }
        if (message.promptSubtitleText !== "") {
            writer.uint32(18).string(message.promptSubtitleText);
        }
        if (message.obfuscatedPhone !== "") {
            writer.uint32(26).string(message.obfuscatedPhone);
        }
        if (message.obfuscatedEmail !== "") {
            writer.uint32(34).string(message.obfuscatedEmail);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSelectCommunicationChannel();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.promptTitleText = reader.string();
                    break;
                case 2:
                    message.promptSubtitleText = reader.string();
                    break;
                case 3:
                    message.obfuscatedPhone = reader.string();
                    break;
                case 4:
                    message.obfuscatedEmail = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseSelectCommunicationChannel();
        message.promptTitleText = object.promptTitleText ?? "";
        message.promptSubtitleText = object.promptSubtitleText ?? "";
        message.obfuscatedPhone = object.obfuscatedPhone ?? "";
        message.obfuscatedEmail = object.obfuscatedEmail ?? "";
        return message;
    },
};
function createBaseAppChallengeAnswer() {
    return { transparentChallengeAnswers: [], visibleChallengeAnswer: undefined };
}
exports.AppChallengeAnswer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.transparentChallengeAnswers) {
            exports.TransparentChallengeAnswer.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.visibleChallengeAnswer?.$case ===
            "communicationChannelInputAnswer") {
            exports.CommunicationChannelInputAnswer.encode(message.visibleChallengeAnswer.communicationChannelInputAnswer, writer.uint32(42).fork()).ldelim();
        }
        if (message.visibleChallengeAnswer?.$case ===
            "communicationChannelVerificationAnswer") {
            exports.CommunicationChannelVerificationAnswer.encode(message.visibleChallengeAnswer.communicationChannelVerificationAnswer, writer.uint32(50).fork()).ldelim();
        }
        if (message.visibleChallengeAnswer?.$case === "webChallengeAnswer") {
            exports.WebViewChallengeAnswer.encode(message.visibleChallengeAnswer.webChallengeAnswer, writer.uint32(58).fork()).ldelim();
        }
        if (message.visibleChallengeAnswer?.$case ===
            "requestResumeChallengeLoopAnswer") {
            exports.RequestResumeChallengeLoopAnswer.encode(message.visibleChallengeAnswer.requestResumeChallengeLoopAnswer, writer.uint32(66).fork()).ldelim();
        }
        if (message.visibleChallengeAnswer?.$case ===
            "passkeyAuthenticationChallengeAnswer") {
            exports.PasskeyAuthenticationChallengeAnswer.encode(message.visibleChallengeAnswer.passkeyAuthenticationChallengeAnswer, writer.uint32(74).fork()).ldelim();
        }
        if (message.visibleChallengeAnswer?.$case === "otpChallengeAnswer") {
            exports.OTPChallengeAnswer.encode(message.visibleChallengeAnswer.otpChallengeAnswer, writer.uint32(82).fork()).ldelim();
        }
        if (message.visibleChallengeAnswer?.$case ===
            "securityQuestionChallengeAnswer") {
            exports.SecurityQuestionChallengeAnswer.encode(message.visibleChallengeAnswer.securityQuestionChallengeAnswer, writer.uint32(90).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAppChallengeAnswer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.transparentChallengeAnswers.push(exports.TransparentChallengeAnswer.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.visibleChallengeAnswer = {
                        $case: "communicationChannelInputAnswer",
                        communicationChannelInputAnswer: exports.CommunicationChannelInputAnswer.decode(reader, reader.uint32()),
                    };
                    break;
                case 6:
                    message.visibleChallengeAnswer = {
                        $case: "communicationChannelVerificationAnswer",
                        communicationChannelVerificationAnswer: exports.CommunicationChannelVerificationAnswer.decode(reader, reader.uint32()),
                    };
                    break;
                case 7:
                    message.visibleChallengeAnswer = {
                        $case: "webChallengeAnswer",
                        webChallengeAnswer: exports.WebViewChallengeAnswer.decode(reader, reader.uint32()),
                    };
                    break;
                case 8:
                    message.visibleChallengeAnswer = {
                        $case: "requestResumeChallengeLoopAnswer",
                        requestResumeChallengeLoopAnswer: exports.RequestResumeChallengeLoopAnswer.decode(reader, reader.uint32()),
                    };
                    break;
                case 9:
                    message.visibleChallengeAnswer = {
                        $case: "passkeyAuthenticationChallengeAnswer",
                        passkeyAuthenticationChallengeAnswer: exports.PasskeyAuthenticationChallengeAnswer.decode(reader, reader.uint32()),
                    };
                    break;
                case 10:
                    message.visibleChallengeAnswer = {
                        $case: "otpChallengeAnswer",
                        otpChallengeAnswer: exports.OTPChallengeAnswer.decode(reader, reader.uint32()),
                    };
                    break;
                case 11:
                    message.visibleChallengeAnswer = {
                        $case: "securityQuestionChallengeAnswer",
                        securityQuestionChallengeAnswer: exports.SecurityQuestionChallengeAnswer.decode(reader, reader.uint32()),
                    };
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseAppChallengeAnswer();
        message.transparentChallengeAnswers =
            object.transparentChallengeAnswers?.map((e) => exports.TransparentChallengeAnswer.fromPartial(e)) || [];
        if (object.visibleChallengeAnswer?.$case ===
            "communicationChannelInputAnswer" &&
            object.visibleChallengeAnswer?.communicationChannelInputAnswer !==
                undefined &&
            object.visibleChallengeAnswer?.communicationChannelInputAnswer !== null) {
            message.visibleChallengeAnswer = {
                $case: "communicationChannelInputAnswer",
                communicationChannelInputAnswer: exports.CommunicationChannelInputAnswer.fromPartial(object.visibleChallengeAnswer.communicationChannelInputAnswer),
            };
        }
        if (object.visibleChallengeAnswer?.$case ===
            "communicationChannelVerificationAnswer" &&
            object.visibleChallengeAnswer?.communicationChannelVerificationAnswer !==
                undefined &&
            object.visibleChallengeAnswer?.communicationChannelVerificationAnswer !==
                null) {
            message.visibleChallengeAnswer = {
                $case: "communicationChannelVerificationAnswer",
                communicationChannelVerificationAnswer: exports.CommunicationChannelVerificationAnswer.fromPartial(object.visibleChallengeAnswer.communicationChannelVerificationAnswer),
            };
        }
        if (object.visibleChallengeAnswer?.$case === "webChallengeAnswer" &&
            object.visibleChallengeAnswer?.webChallengeAnswer !== undefined &&
            object.visibleChallengeAnswer?.webChallengeAnswer !== null) {
            message.visibleChallengeAnswer = {
                $case: "webChallengeAnswer",
                webChallengeAnswer: exports.WebViewChallengeAnswer.fromPartial(object.visibleChallengeAnswer.webChallengeAnswer),
            };
        }
        if (object.visibleChallengeAnswer?.$case ===
            "requestResumeChallengeLoopAnswer" &&
            object.visibleChallengeAnswer?.requestResumeChallengeLoopAnswer !==
                undefined &&
            object.visibleChallengeAnswer?.requestResumeChallengeLoopAnswer !== null) {
            message.visibleChallengeAnswer = {
                $case: "requestResumeChallengeLoopAnswer",
                requestResumeChallengeLoopAnswer: exports.RequestResumeChallengeLoopAnswer.fromPartial(object.visibleChallengeAnswer.requestResumeChallengeLoopAnswer),
            };
        }
        if (object.visibleChallengeAnswer?.$case ===
            "passkeyAuthenticationChallengeAnswer" &&
            object.visibleChallengeAnswer?.passkeyAuthenticationChallengeAnswer !==
                undefined &&
            object.visibleChallengeAnswer?.passkeyAuthenticationChallengeAnswer !==
                null) {
            message.visibleChallengeAnswer = {
                $case: "passkeyAuthenticationChallengeAnswer",
                passkeyAuthenticationChallengeAnswer: exports.PasskeyAuthenticationChallengeAnswer.fromPartial(object.visibleChallengeAnswer.passkeyAuthenticationChallengeAnswer),
            };
        }
        if (object.visibleChallengeAnswer?.$case === "otpChallengeAnswer" &&
            object.visibleChallengeAnswer?.otpChallengeAnswer !== undefined &&
            object.visibleChallengeAnswer?.otpChallengeAnswer !== null) {
            message.visibleChallengeAnswer = {
                $case: "otpChallengeAnswer",
                otpChallengeAnswer: exports.OTPChallengeAnswer.fromPartial(object.visibleChallengeAnswer.otpChallengeAnswer),
            };
        }
        if (object.visibleChallengeAnswer?.$case ===
            "securityQuestionChallengeAnswer" &&
            object.visibleChallengeAnswer?.securityQuestionChallengeAnswer !==
                undefined &&
            object.visibleChallengeAnswer?.securityQuestionChallengeAnswer !== null) {
            message.visibleChallengeAnswer = {
                $case: "securityQuestionChallengeAnswer",
                securityQuestionChallengeAnswer: exports.SecurityQuestionChallengeAnswer.fromPartial(object.visibleChallengeAnswer.securityQuestionChallengeAnswer),
            };
        }
        return message;
    },
};
function createBaseTransparentChallengeAnswer() {
    return { payload: undefined };
}
exports.TransparentChallengeAnswer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.payload?.$case === "vendorIntegrityChallengeAnswer") {
            exports.VendorIntegrityChallengeAnswer.encode(message.payload.vendorIntegrityChallengeAnswer, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTransparentChallengeAnswer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.payload = {
                        $case: "vendorIntegrityChallengeAnswer",
                        vendorIntegrityChallengeAnswer: exports.VendorIntegrityChallengeAnswer.decode(reader, reader.uint32()),
                    };
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseTransparentChallengeAnswer();
        if (object.payload?.$case === "vendorIntegrityChallengeAnswer" &&
            object.payload?.vendorIntegrityChallengeAnswer !== undefined &&
            object.payload?.vendorIntegrityChallengeAnswer !== null) {
            message.payload = {
                $case: "vendorIntegrityChallengeAnswer",
                vendorIntegrityChallengeAnswer: exports.VendorIntegrityChallengeAnswer.fromPartial(object.payload.vendorIntegrityChallengeAnswer),
            };
        }
        return message;
    },
};
function createBaseChallengeAnswer() {
    return { challengeAnswer: undefined };
}
exports.ChallengeAnswer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.challengeAnswer?.$case === "otpChallengeAnswer") {
            exports.OTPChallengeAnswer.encode(message.challengeAnswer.otpChallengeAnswer, writer.uint32(10).fork()).ldelim();
        }
        if (message.challengeAnswer?.$case === "passwordChallengeAnswer") {
            exports.PasswordChallengeAnswer.encode(message.challengeAnswer.passwordChallengeAnswer, writer.uint32(18).fork()).ldelim();
        }
        if (message.challengeAnswer?.$case === "securityQuestionChallengeAnswer") {
            exports.SecurityQuestionChallengeAnswer.encode(message.challengeAnswer.securityQuestionChallengeAnswer, writer.uint32(26).fork()).ldelim();
        }
        if (message.challengeAnswer?.$case === "tivChallengeAnswer") {
            exports.TIVChallengeAnswer.encode(message.challengeAnswer.tivChallengeAnswer, writer.uint32(34).fork()).ldelim();
        }
        if (message.challengeAnswer?.$case === "twoFaChallengeAnswer") {
            exports.TwoFAChallengeAnswer.encode(message.challengeAnswer.twoFaChallengeAnswer, writer.uint32(42).fork()).ldelim();
        }
        if (message.challengeAnswer?.$case === "selectCommunicationChannelAnswer") {
            exports.SelectCommunicationChannelAnswer.encode(message.challengeAnswer.selectCommunicationChannelAnswer, writer.uint32(50).fork()).ldelim();
        }
        if (message.challengeAnswer?.$case === "communicationChannelChallengeAnswer") {
            exports.CommunicationChannelChallengeAnswer.encode(message.challengeAnswer.communicationChannelChallengeAnswer, writer.uint32(58).fork()).ldelim();
        }
        if (message.challengeAnswer?.$case ===
            "internalIdentityVerificationChallengeAnswer") {
            exports.InternalIdentityVerificationChallengeAnswer.encode(message.challengeAnswer.internalIdentityVerificationChallengeAnswer, writer.uint32(66).fork()).ldelim();
        }
        if (message.challengeAnswer?.$case === "vendorIntegrityChallengeAnswer") {
            exports.VendorIntegrityChallengeAnswer.encode(message.challengeAnswer.vendorIntegrityChallengeAnswer, writer.uint32(74).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChallengeAnswer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.challengeAnswer = {
                        $case: "otpChallengeAnswer",
                        otpChallengeAnswer: exports.OTPChallengeAnswer.decode(reader, reader.uint32()),
                    };
                    break;
                case 2:
                    message.challengeAnswer = {
                        $case: "passwordChallengeAnswer",
                        passwordChallengeAnswer: exports.PasswordChallengeAnswer.decode(reader, reader.uint32()),
                    };
                    break;
                case 3:
                    message.challengeAnswer = {
                        $case: "securityQuestionChallengeAnswer",
                        securityQuestionChallengeAnswer: exports.SecurityQuestionChallengeAnswer.decode(reader, reader.uint32()),
                    };
                    break;
                case 4:
                    message.challengeAnswer = {
                        $case: "tivChallengeAnswer",
                        tivChallengeAnswer: exports.TIVChallengeAnswer.decode(reader, reader.uint32()),
                    };
                    break;
                case 5:
                    message.challengeAnswer = {
                        $case: "twoFaChallengeAnswer",
                        twoFaChallengeAnswer: exports.TwoFAChallengeAnswer.decode(reader, reader.uint32()),
                    };
                    break;
                case 6:
                    message.challengeAnswer = {
                        $case: "selectCommunicationChannelAnswer",
                        selectCommunicationChannelAnswer: exports.SelectCommunicationChannelAnswer.decode(reader, reader.uint32()),
                    };
                    break;
                case 7:
                    message.challengeAnswer = {
                        $case: "communicationChannelChallengeAnswer",
                        communicationChannelChallengeAnswer: exports.CommunicationChannelChallengeAnswer.decode(reader, reader.uint32()),
                    };
                    break;
                case 8:
                    message.challengeAnswer = {
                        $case: "internalIdentityVerificationChallengeAnswer",
                        internalIdentityVerificationChallengeAnswer: exports.InternalIdentityVerificationChallengeAnswer.decode(reader, reader.uint32()),
                    };
                    break;
                case 9:
                    message.challengeAnswer = {
                        $case: "vendorIntegrityChallengeAnswer",
                        vendorIntegrityChallengeAnswer: exports.VendorIntegrityChallengeAnswer.decode(reader, reader.uint32()),
                    };
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseChallengeAnswer();
        if (object.challengeAnswer?.$case === "otpChallengeAnswer" &&
            object.challengeAnswer?.otpChallengeAnswer !== undefined &&
            object.challengeAnswer?.otpChallengeAnswer !== null) {
            message.challengeAnswer = {
                $case: "otpChallengeAnswer",
                otpChallengeAnswer: exports.OTPChallengeAnswer.fromPartial(object.challengeAnswer.otpChallengeAnswer),
            };
        }
        if (object.challengeAnswer?.$case === "passwordChallengeAnswer" &&
            object.challengeAnswer?.passwordChallengeAnswer !== undefined &&
            object.challengeAnswer?.passwordChallengeAnswer !== null) {
            message.challengeAnswer = {
                $case: "passwordChallengeAnswer",
                passwordChallengeAnswer: exports.PasswordChallengeAnswer.fromPartial(object.challengeAnswer.passwordChallengeAnswer),
            };
        }
        if (object.challengeAnswer?.$case === "securityQuestionChallengeAnswer" &&
            object.challengeAnswer?.securityQuestionChallengeAnswer !== undefined &&
            object.challengeAnswer?.securityQuestionChallengeAnswer !== null) {
            message.challengeAnswer = {
                $case: "securityQuestionChallengeAnswer",
                securityQuestionChallengeAnswer: exports.SecurityQuestionChallengeAnswer.fromPartial(object.challengeAnswer.securityQuestionChallengeAnswer),
            };
        }
        if (object.challengeAnswer?.$case === "tivChallengeAnswer" &&
            object.challengeAnswer?.tivChallengeAnswer !== undefined &&
            object.challengeAnswer?.tivChallengeAnswer !== null) {
            message.challengeAnswer = {
                $case: "tivChallengeAnswer",
                tivChallengeAnswer: exports.TIVChallengeAnswer.fromPartial(object.challengeAnswer.tivChallengeAnswer),
            };
        }
        if (object.challengeAnswer?.$case === "twoFaChallengeAnswer" &&
            object.challengeAnswer?.twoFaChallengeAnswer !== undefined &&
            object.challengeAnswer?.twoFaChallengeAnswer !== null) {
            message.challengeAnswer = {
                $case: "twoFaChallengeAnswer",
                twoFaChallengeAnswer: exports.TwoFAChallengeAnswer.fromPartial(object.challengeAnswer.twoFaChallengeAnswer),
            };
        }
        if (object.challengeAnswer?.$case === "selectCommunicationChannelAnswer" &&
            object.challengeAnswer?.selectCommunicationChannelAnswer !== undefined &&
            object.challengeAnswer?.selectCommunicationChannelAnswer !== null) {
            message.challengeAnswer = {
                $case: "selectCommunicationChannelAnswer",
                selectCommunicationChannelAnswer: exports.SelectCommunicationChannelAnswer.fromPartial(object.challengeAnswer.selectCommunicationChannelAnswer),
            };
        }
        if (object.challengeAnswer?.$case === "communicationChannelChallengeAnswer" &&
            object.challengeAnswer?.communicationChannelChallengeAnswer !==
                undefined &&
            object.challengeAnswer?.communicationChannelChallengeAnswer !== null) {
            message.challengeAnswer = {
                $case: "communicationChannelChallengeAnswer",
                communicationChannelChallengeAnswer: exports.CommunicationChannelChallengeAnswer.fromPartial(object.challengeAnswer.communicationChannelChallengeAnswer),
            };
        }
        if (object.challengeAnswer?.$case ===
            "internalIdentityVerificationChallengeAnswer" &&
            object.challengeAnswer?.internalIdentityVerificationChallengeAnswer !==
                undefined &&
            object.challengeAnswer?.internalIdentityVerificationChallengeAnswer !==
                null) {
            message.challengeAnswer = {
                $case: "internalIdentityVerificationChallengeAnswer",
                internalIdentityVerificationChallengeAnswer: exports.InternalIdentityVerificationChallengeAnswer.fromPartial(object.challengeAnswer.internalIdentityVerificationChallengeAnswer),
            };
        }
        if (object.challengeAnswer?.$case === "vendorIntegrityChallengeAnswer" &&
            object.challengeAnswer?.vendorIntegrityChallengeAnswer !== undefined &&
            object.challengeAnswer?.vendorIntegrityChallengeAnswer !== null) {
            message.challengeAnswer = {
                $case: "vendorIntegrityChallengeAnswer",
                vendorIntegrityChallengeAnswer: exports.VendorIntegrityChallengeAnswer.fromPartial(object.challengeAnswer.vendorIntegrityChallengeAnswer),
            };
        }
        return message;
    },
};
function createBaseCommunicationChannelChallengeAnswer() {
    return { communicationChannel: undefined, communicationChannelAnswer: "" };
}
exports.CommunicationChannelChallengeAnswer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.communicationChannel?.$case === "email") {
            writer.uint32(10).string(message.communicationChannel.email);
        }
        if (message.communicationChannelAnswer !== "") {
            writer.uint32(18).string(message.communicationChannelAnswer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommunicationChannelChallengeAnswer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.communicationChannel = {
                        $case: "email",
                        email: reader.string(),
                    };
                    break;
                case 2:
                    message.communicationChannelAnswer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseCommunicationChannelChallengeAnswer();
        if (object.communicationChannel?.$case === "email" &&
            object.communicationChannel?.email !== undefined &&
            object.communicationChannel?.email !== null) {
            message.communicationChannel = {
                $case: "email",
                email: object.communicationChannel.email,
            };
        }
        message.communicationChannelAnswer =
            object.communicationChannelAnswer ?? "";
        return message;
    },
};
function createBaseCommunicationChannelInputAnswer() {
    return { answer: undefined };
}
exports.CommunicationChannelInputAnswer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.answer?.$case === "email") {
            writer.uint32(10).string(message.answer.email);
        }
        if (message.answer?.$case === "phone") {
            writer.uint32(18).string(message.answer.phone);
        }
        if (message.answer?.$case === "phoneInput") {
            exports.CommunicationChannelInputAnswer_PhoneInput.encode(message.answer.phoneInput, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommunicationChannelInputAnswer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.answer = { $case: "email", email: reader.string() };
                    break;
                case 2:
                    message.answer = { $case: "phone", phone: reader.string() };
                    break;
                case 3:
                    message.answer = {
                        $case: "phoneInput",
                        phoneInput: exports.CommunicationChannelInputAnswer_PhoneInput.decode(reader, reader.uint32()),
                    };
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseCommunicationChannelInputAnswer();
        if (object.answer?.$case === "email" &&
            object.answer?.email !== undefined &&
            object.answer?.email !== null) {
            message.answer = { $case: "email", email: object.answer.email };
        }
        if (object.answer?.$case === "phone" &&
            object.answer?.phone !== undefined &&
            object.answer?.phone !== null) {
            message.answer = { $case: "phone", phone: object.answer.phone };
        }
        if (object.answer?.$case === "phoneInput" &&
            object.answer?.phoneInput !== undefined &&
            object.answer?.phoneInput !== null) {
            message.answer = {
                $case: "phoneInput",
                phoneInput: exports.CommunicationChannelInputAnswer_PhoneInput.fromPartial(object.answer.phoneInput),
            };
        }
        return message;
    },
};
function createBaseCommunicationChannelInputAnswer_PhoneInput() {
    return {
        phoneNumber: "",
        verificationMethodRequested: 0,
        phoneNumberCountryCode: "",
    };
}
exports.CommunicationChannelInputAnswer_PhoneInput = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.phoneNumber !== "") {
            writer.uint32(10).string(message.phoneNumber);
        }
        if (message.verificationMethodRequested !== 0) {
            writer.uint32(16).int32(message.verificationMethodRequested);
        }
        if (message.phoneNumberCountryCode !== "") {
            writer.uint32(26).string(message.phoneNumberCountryCode);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommunicationChannelInputAnswer_PhoneInput();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.phoneNumber = reader.string();
                    break;
                case 2:
                    message.verificationMethodRequested = reader.int32();
                    break;
                case 3:
                    message.phoneNumberCountryCode = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseCommunicationChannelInputAnswer_PhoneInput();
        message.phoneNumber = object.phoneNumber ?? "";
        message.verificationMethodRequested =
            object.verificationMethodRequested ?? 0;
        message.phoneNumberCountryCode = object.phoneNumberCountryCode ?? "";
        return message;
    },
};
function createBaseCommunicationChannelVerificationAnswer() {
    return { answer: undefined };
}
exports.CommunicationChannelVerificationAnswer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.answer?.$case === "otp") {
            writer.uint32(10).string(message.answer.otp);
        }
        if (message.answer?.$case === "resendRequest") {
            exports.CommunicationChannelVerificationAnswer_ResendRequest.encode(message.answer.resendRequest, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommunicationChannelVerificationAnswer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.answer = { $case: "otp", otp: reader.string() };
                    break;
                case 2:
                    message.answer = {
                        $case: "resendRequest",
                        resendRequest: exports.CommunicationChannelVerificationAnswer_ResendRequest.decode(reader, reader.uint32()),
                    };
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseCommunicationChannelVerificationAnswer();
        if (object.answer?.$case === "otp" &&
            object.answer?.otp !== undefined &&
            object.answer?.otp !== null) {
            message.answer = { $case: "otp", otp: object.answer.otp };
        }
        if (object.answer?.$case === "resendRequest" &&
            object.answer?.resendRequest !== undefined &&
            object.answer?.resendRequest !== null) {
            message.answer = {
                $case: "resendRequest",
                resendRequest: exports.CommunicationChannelVerificationAnswer_ResendRequest.fromPartial(object.answer.resendRequest),
            };
        }
        return message;
    },
};
function createBaseCommunicationChannelVerificationAnswer_ResendRequest() {
    return {};
}
exports.CommunicationChannelVerificationAnswer_ResendRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommunicationChannelVerificationAnswer_ResendRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(_) {
        const message = createBaseCommunicationChannelVerificationAnswer_ResendRequest();
        return message;
    },
};
function createBaseWebViewChallengeAnswer() {
    return { answerPayload: new Uint8Array(), error: 0 };
}
exports.WebViewChallengeAnswer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.answerPayload.length !== 0) {
            writer.uint32(10).bytes(message.answerPayload);
        }
        if (message.error !== 0) {
            writer.uint32(16).int32(message.error);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebViewChallengeAnswer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.answerPayload = reader.bytes();
                    break;
                case 2:
                    message.error = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseWebViewChallengeAnswer();
        message.answerPayload = object.answerPayload ?? new Uint8Array();
        message.error = object.error ?? 0;
        return message;
    },
};
function createBaseRequestResumeChallengeLoopAnswer() {
    return { reason: 0 };
}
exports.RequestResumeChallengeLoopAnswer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.reason !== 0) {
            writer.uint32(8).int32(message.reason);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestResumeChallengeLoopAnswer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.reason = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseRequestResumeChallengeLoopAnswer();
        message.reason = object.reason ?? 0;
        return message;
    },
};
function createBaseOTPChallengeAnswer() {
    return { otp: "", rememberDevice: false };
}
exports.OTPChallengeAnswer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.otp !== "") {
            writer.uint32(10).string(message.otp);
        }
        if (message.rememberDevice === true) {
            writer.uint32(16).bool(message.rememberDevice);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOTPChallengeAnswer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.otp = reader.string();
                    break;
                case 2:
                    message.rememberDevice = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseOTPChallengeAnswer();
        message.otp = object.otp ?? "";
        message.rememberDevice = object.rememberDevice ?? false;
        return message;
    },
};
function createBasePasswordChallengeAnswer() {
    return { password: "" };
}
exports.PasswordChallengeAnswer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.password !== "") {
            writer.uint32(10).string(message.password);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePasswordChallengeAnswer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.password = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBasePasswordChallengeAnswer();
        message.password = object.password ?? "";
        return message;
    },
};
function createBaseSecurityQuestionChallengeAnswer() {
    return { securityQuestionType: 0, securityQuestionAnswer: undefined };
}
exports.SecurityQuestionChallengeAnswer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.securityQuestionType !== 0) {
            writer.uint32(8).int32(message.securityQuestionType);
        }
        if (message.securityQuestionAnswer?.$case === "text") {
            writer.uint32(18).string(message.securityQuestionAnswer.text);
        }
        if (message.securityQuestionAnswer?.$case === "date") {
            date_1.DateMessage.encode(message.securityQuestionAnswer.date, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSecurityQuestionChallengeAnswer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.securityQuestionType = reader.int32();
                    break;
                case 2:
                    message.securityQuestionAnswer = {
                        $case: "text",
                        text: reader.string(),
                    };
                    break;
                case 3:
                    message.securityQuestionAnswer = {
                        $case: "date",
                        date: date_1.DateMessage.decode(reader, reader.uint32()),
                    };
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseSecurityQuestionChallengeAnswer();
        message.securityQuestionType = object.securityQuestionType ?? 0;
        if (object.securityQuestionAnswer?.$case === "text" &&
            object.securityQuestionAnswer?.text !== undefined &&
            object.securityQuestionAnswer?.text !== null) {
            message.securityQuestionAnswer = {
                $case: "text",
                text: object.securityQuestionAnswer.text,
            };
        }
        if (object.securityQuestionAnswer?.$case === "date" &&
            object.securityQuestionAnswer?.date !== undefined &&
            object.securityQuestionAnswer?.date !== null) {
            message.securityQuestionAnswer = {
                $case: "date",
                date: date_1.DateMessage.fromPartial(object.securityQuestionAnswer.date),
            };
        }
        return message;
    },
};
function createBaseTIVChallengeAnswer() {
    return { transactionId: "", broadcastId: "" };
}
exports.TIVChallengeAnswer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.transactionId !== "") {
            writer.uint32(10).string(message.transactionId);
        }
        if (message.broadcastId !== "") {
            writer.uint32(18).string(message.broadcastId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTIVChallengeAnswer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.transactionId = reader.string();
                    break;
                case 2:
                    message.broadcastId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseTIVChallengeAnswer();
        message.transactionId = object.transactionId ?? "";
        message.broadcastId = object.broadcastId ?? "";
        return message;
    },
};
function createBaseTwoFAChallengeAnswer() {
    return { twoFaCode: "", rememberDevice: false, communicationChannel: 0 };
}
exports.TwoFAChallengeAnswer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.twoFaCode !== "") {
            writer.uint32(10).string(message.twoFaCode);
        }
        if (message.rememberDevice === true) {
            writer.uint32(16).bool(message.rememberDevice);
        }
        if (message.communicationChannel !== 0) {
            writer.uint32(24).int32(message.communicationChannel);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTwoFAChallengeAnswer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.twoFaCode = reader.string();
                    break;
                case 2:
                    message.rememberDevice = reader.bool();
                    break;
                case 3:
                    message.communicationChannel = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseTwoFAChallengeAnswer();
        message.twoFaCode = object.twoFaCode ?? "";
        message.rememberDevice = object.rememberDevice ?? false;
        message.communicationChannel = object.communicationChannel ?? 0;
        return message;
    },
};
function createBaseTOTPChallengeAnswer() {
    return { totp: "", rememberDevice: false };
}
exports.TOTPChallengeAnswer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.totp !== "") {
            writer.uint32(10).string(message.totp);
        }
        if (message.rememberDevice === true) {
            writer.uint32(16).bool(message.rememberDevice);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTOTPChallengeAnswer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.totp = reader.string();
                    break;
                case 2:
                    message.rememberDevice = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseTOTPChallengeAnswer();
        message.totp = object.totp ?? "";
        message.rememberDevice = object.rememberDevice ?? false;
        return message;
    },
};
function createBaseSelectCommunicationChannelAnswer() {
    return { selectedCommunicationChannel: 0 };
}
exports.SelectCommunicationChannelAnswer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.selectedCommunicationChannel !== 0) {
            writer.uint32(8).int32(message.selectedCommunicationChannel);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSelectCommunicationChannelAnswer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.selectedCommunicationChannel = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseSelectCommunicationChannelAnswer();
        message.selectedCommunicationChannel =
            object.selectedCommunicationChannel ?? 0;
        return message;
    },
};
function createBaseInternalIdentityVerificationChallengeAnswer() {
    return { identity: "", encodedToken: "" };
}
exports.InternalIdentityVerificationChallengeAnswer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.identity !== "") {
            writer.uint32(10).string(message.identity);
        }
        if (message.encodedToken !== "") {
            writer.uint32(18).string(message.encodedToken);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInternalIdentityVerificationChallengeAnswer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.identity = reader.string();
                    break;
                case 2:
                    message.encodedToken = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseInternalIdentityVerificationChallengeAnswer();
        message.identity = object.identity ?? "";
        message.encodedToken = object.encodedToken ?? "";
        return message;
    },
};
function createBaseVendorIntegrityChallengeAnswer() {
    return { type: 0, vendorAttestationPayload: new Uint8Array() };
}
exports.VendorIntegrityChallengeAnswer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.type !== 0) {
            writer.uint32(8).int32(message.type);
        }
        if (message.vendorAttestationPayload.length !== 0) {
            writer.uint32(50).bytes(message.vendorAttestationPayload);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVendorIntegrityChallengeAnswer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.type = reader.int32();
                    break;
                case 6:
                    message.vendorAttestationPayload = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseVendorIntegrityChallengeAnswer();
        message.type = object.type ?? 0;
        message.vendorAttestationPayload =
            object.vendorAttestationPayload ?? new Uint8Array();
        return message;
    },
};
function createBasePasskeyAuthenticationChallengeAnswer() {
    return { passkeyAuthenticationPayload: undefined };
}
exports.PasskeyAuthenticationChallengeAnswer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.passkeyAuthenticationPayload !== undefined) {
            passkey_authentication_payload_1.PasskeyAuthenticationPayload.encode(message.passkeyAuthenticationPayload, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePasskeyAuthenticationChallengeAnswer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.passkeyAuthenticationPayload =
                        passkey_authentication_payload_1.PasskeyAuthenticationPayload.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBasePasskeyAuthenticationChallengeAnswer();
        message.passkeyAuthenticationPayload =
            object.passkeyAuthenticationPayload !== undefined &&
                object.passkeyAuthenticationPayload !== null
                ? passkey_authentication_payload_1.PasskeyAuthenticationPayload.fromPartial(object.passkeyAuthenticationPayload)
                : undefined;
        return message;
    },
};
//# sourceMappingURL=challenge_orchestration_challenge_data.js.map